import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    input,
    viewChildren,
    ViewEncapsulation,
} from '@angular/core';
import { TextBlockWithSideBarItem } from '@shared/text-block-with-side-bar/text-block-wht-side-bar.type';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { JoinClassNamesPipe } from '@shared/join/join-class-names.pipe';
import { ScrollComponent } from '@shared/scroll/scroll.component';

@Component({
    selector: 'companyid-text-block-with-side-bar',
    imports: [ContentWrapperComponent, JoinClassNamesPipe],
    templateUrl: './text-block-with-side-bar.component.html',
    styleUrl: './text-block-with-side-bar.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextBlockWithSideBarComponent extends ScrollComponent implements AfterViewInit {
    public contentItems = input.required<TextBlockWithSideBarItem[]>();
    public itemsBlock = viewChildren<string, ElementRef<HTMLDivElement>>('itemsBlock', {
        read: ElementRef,
    });

    public readonly scrollIntoViewPosition = 'start';

    public override isInViewport(elm: HTMLElement): boolean {
        const rect = elm.getBoundingClientRect();
        const windowHeight = window.innerHeight || this.document.documentElement.clientHeight;
        const windowWidth = window.innerWidth || this.document.documentElement.clientWidth;

        const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
        const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;

        return vertInView && horInView;
    }

    public ngAfterViewInit(): void {
        this.onScroll(this.itemsBlock());
    }

    public handleKeydown(event: KeyboardEvent, id: number): void {
        if (event.key === 'Enter') {
            this.anchorScroll(id, this.itemsBlock(), this.scrollIntoViewPosition);
        }
    }
}
